<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_303_1555)">
      <path
        d="M11.4271 1.4147L11.5876 1.51116L11.7741 1.4939L13.7639 1.30971L14.8605 2.98021L14.9632 3.13677L15.1387 3.20213L17.0114 3.89951L17.2746 5.88038L17.2992 6.06603L17.429 6.20106L18.8136 7.64189L18.1913 9.54079L18.133 9.71875L18.1913 9.89671L18.8136 11.7956L17.429 13.2364L17.2992 13.3715L17.2746 13.5571L17.0114 15.538L15.1387 16.2354L14.9632 16.3007L14.8605 16.4573L13.7639 18.1278L11.7741 17.9436L11.5876 17.9263L11.4271 18.0228L9.71429 19.0521L8.00149 18.0228L7.84097 17.9263L7.65449 17.9436L5.66471 18.1278L4.56811 16.4573L4.46534 16.3007L4.28984 16.2354L2.4172 15.538L2.15401 13.5571L2.12934 13.3715L1.99957 13.2364L0.614969 11.7956L1.2373 9.89671L1.29563 9.71875L1.2373 9.54079L0.614969 7.64189L1.99957 6.20106L2.12934 6.06603L2.15401 5.88038L2.4172 3.89951L4.28984 3.20213L4.46534 3.13677L4.56811 2.98021L5.66471 1.30971L7.65449 1.4939L7.84097 1.51116L8.00149 1.41469L9.71429 0.385418L11.4271 1.4147Z"
        :fill="color"
        stroke="#000517"
        stroke-width="1.14286"
      />
      <path
        d="M6.70611 9.77788L6.60545 9.67722L6.50443 9.77753L5.89934 10.3784L5.79761 10.4794L5.89898 10.5807L8.281 12.9628L8.38202 13.0638L8.48303 12.9628L13.5965 7.84931L13.6975 7.74829L13.5965 7.64728L12.9957 7.04645L12.8947 6.94548L12.7937 7.0464L8.38207 11.4538L6.70611 9.77788Z"
        fill="#000517"
        stroke="#000517"
        stroke-width="0.285714"
      />
    </g>
    <defs>
      <clipPath id="clip0_303_1555">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.00439453)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'CreatorCheckmark',
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
.creator-checkmark-icon {
  width: 20px;
  height: 20px;
}
</style>
